import { ref } from 'vue';
import axios from './useAxios';

export default function () {
    const notifications = ref([]);

    const getNotificationsByUser = async (userId) => {
        const res = await axios.get(`/notifications/user/${userId}`);
        if (res.status === 200) {
            notifications.value = res.data.items;
        }
    };

    const markOneAsRead = async (id) => {
        const response = await axios.put(`/notifications/markOneAsRead/${id}`);
        return response.data;
    };

    const markAllAsRead = async (id) => {
        const response = await axios.put(`/notifications/markAllAsRead/${id}`);
        return response.data;
    };

    return {
        notifications,
        getNotificationsByUser,
        markOneAsRead,
        markAllAsRead,
    };
}
